import {
  AddFeeBtn,
  Container,
  DeleteBtn,
  EditBtn,
  Header,
  Title
} from './style';
import {
  Table,
  TableHead,
  TableRow,
  TH,
  TableBody,
  TableData
} from '../../../component/table';
import { AddFeeModal } from '../modal/addFee';
import { useState } from 'react';
import { useGetAllDeliveryFeesQuery } from '../../../store/shopping/api';
import { currencyFormatter } from '../../../utils/currencyConverter';
import { Loader } from '../../../component/loader';
import { IFee } from '../../../store/shopping/interface';
import { EmptyState, EmptyTxt } from '../../../component/emptyState';

export const ViewFees = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [editItem, setEditItem] = useState<IFee | null>(null);
  const { data: deliveryFees, isLoading } = useGetAllDeliveryFeesQuery();

  return (
    <Container>
      {(showAddModal || editItem !== null) && (
        <AddFeeModal
          editItem={editItem}
          close={() => {
            setEditItem(null);
            setShowAddModal(false);
          }}
        />
      )}
      {isLoading && <Loader />}
      <Header>
        <Title>All fees</Title>
        <AddFeeBtn onClick={() => setShowAddModal(true)}>Add fee</AddFeeBtn>
      </Header>
      {!deliveryFees?.data.length && (
        <EmptyState>
          <EmptyTxt>
            No fees added yet, click on the button below to add Fees
          </EmptyTxt>
          <AddFeeBtn onClick={() => setShowAddModal(true)}>Add fee</AddFeeBtn>
        </EmptyState>
      )}
      {deliveryFees?.data.length && (
        <Table>
          <TableHead>
            <TableRow>
              <TH>S/N</TH>
              <TH>State</TH>
              <TH>Delivery Fee(Per KM)</TH>
              <TH>Service Fee</TH>
              <TH>Action </TH>
            </TableRow>
          </TableHead>
          <TableBody>
            {deliveryFees?.data.map((data, index) => (
              <TableRow key={data._id}>
                <TableData>{++index}</TableData>
                <TableData>{data.state}</TableData>
                <TableData>N{currencyFormatter(data.fee)}</TableData>
                <TableData>N{currencyFormatter(data.serviceFee)}</TableData>
                <TableData>
                  <EditBtn onClick={() => setEditItem(data)}>Edit</EditBtn>
                  <DeleteBtn>Delete</DeleteBtn>
                </TableData>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Container>
  );
};
